<fgb-page-header [pageTitle]="'games.page.trivia.title'" [showBalance]="true" [backButtonLink]="'/games'">
  <ng-template>
    <img [src]="'/images/trivia-banner.png' | contentAssetImage" />
    <fgb-game-nav routeLink="trivia" />
  </ng-template>
</fgb-page-header>
<router-outlet></router-outlet>
